module.exports = __webpack_public_path__ + "static/media/YM58_1.588262f5.jpg";